import config from 'config';
import fetchWithToken from './provider/fetch';

const getQuoteEndPoint = (accountKey: string): string => `${config.UNIFIED_COMMERCE_URL}/rest/v2/quote/${accountKey}`;

const getPayInvoiceEndPoint = (accountKey: string): string =>
  `${config.UNIFIED_COMMERCE_URL}/rest/v2/billing/${accountKey}/invoice/paynow`;

export const daoProcessQuotePost = (
  accountKey: string,
  quoteCode: string,
  payload: object,
  requestOriginValue: string,
): Promise<object> =>
  fetchWithToken({
    reqUrl: `${getQuoteEndPoint(accountKey)}/process/${quoteCode}`,
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      request_origin: requestOriginValue,
    },
  });

export const daoInvoicePayPost = (accountKey: string, sessionId: string, requestOriginValue: string): Promise<object> =>
  fetchWithToken({
    method: 'POST',
    reqUrl: getPayInvoiceEndPoint(accountKey),
    body: JSON.stringify({ sessionId }),
    headers: {
      request_origin: requestOriginValue,
    },
  });

export default {
  daoProcessQuotePost,
  daoInvoicePayPost,
};
